import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../app/store';
import { copy } from '../../services/util';
import { weaveShareUtil } from './weaveShareUtil';
import { WeaveTrainerState } from './weaveTrainerSlice';

const initialState: WeaveShareState = {
  visible: false
};

export interface WeaveShareState {
  visible: boolean
};

export const encodeBuild = (): AppThunk<string> => (_, getState) => {
  return weaveShareUtil.encode(getState());
};

export const decodeBuild = (code: string): AppThunk => (dispatch) => {
  const state = weaveShareUtil.decode(code);
  dispatch(slice.actions.decodeBuildFulfilled(state));
}

export const copyUrl = (url: string): AppThunk => (dispatch) => {
  copy(url);
  dispatch(slice.actions.hide());
}

export const slice = createSlice({
  name: 'weaveShare',
  initialState: initialState,
  reducers: {
    show: (state) => {
      state.visible = true;
    },
    hide: (state) => {
      state.visible = false;
    },
    decodeBuildFulfilled: (state, action: PayloadAction<WeaveTrainerState>) => {
      //
    }
  }
});

export default slice.reducer;
export const { show, hide, decodeBuildFulfilled } = slice.actions;
